export default __webpack_public_path__ + "static/media/DTEX-UC2-Seq5-Reports-Digital-Full.5441a792.png";